// src/pages/NoticiaPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TituloComponent from "../components/Titulo/TituloComponent";
import { getNoticiaById, getNoticiaByTitulo } from "../services/NoticiasService";

const isObjectId = (str) => /^[a-f0-9]{24}$/i.test(str);

const NoticiaPage = () => {
  const { param } = useParams(); // pode ser _id ou título
  const [noticia, setNoticia] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        setErro("");
        setNoticia(null);

        // tenta por ID primeiro
        if (isObjectId(param)) {
          const n = await getNoticiaById(param);
          setNoticia(n);
          return;
        }

        // senão, tenta por TÍTULO
        const tituloDecoded = decodeURIComponent(param);
        const n = await getNoticiaByTitulo(tituloDecoded);
        setNoticia(n);
      } catch (e) {
        console.error(e);
        setErro("Notícia não encontrada.");
      }
    };

    fetchNoticia();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [param]);

  if (erro) return <div style={{ padding: 16 }}>{erro}</div>;
  if (!noticia) return <div style={{ padding: 16 }}>Carregando...</div>;

  return (
    <div style={{ padding: 16 }}>
      <TituloComponent name="Notícia" />
      <h1>{noticia.titulo}</h1>
      <p><strong>Data:</strong> {new Date(noticia.data).toLocaleDateString()}</p>
      {noticia.imagem && (
        <img
          src={noticia.imagem}
          alt={noticia.titulo}
          style={{ maxWidth: "100%", borderRadius: 12, margin: "12px 0" }}
        />
      )}
      <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
        {noticia.textoCompleto ?? noticia.textoDescription}
      </div>
    </div>
  );
};

export default NoticiaPage;
